"use client";

import { Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Zabezpiecz() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.18
  });
  const stars = [{
    top: "8%",
    left: "6%",
    size: 56,
    rotate: -12,
    opacity: 0.9
  }, {
    top: "14%",
    left: "22%",
    size: 32,
    rotate: 18,
    opacity: 0.7
  }, {
    top: "6%",
    left: "44%",
    size: 40,
    rotate: -6,
    opacity: 0.8
  }, {
    top: "10%",
    left: "68%",
    size: 48,
    rotate: 22,
    opacity: 0.85
  }, {
    top: "18%",
    left: "86%",
    size: 36,
    rotate: -18,
    opacity: 0.75
  }, {
    top: "38%",
    left: "4%",
    size: 44,
    rotate: 10,
    opacity: 0.8
  }, {
    top: "44%",
    left: "92%",
    size: 52,
    rotate: -22,
    opacity: 0.85
  }, {
    top: "62%",
    left: "10%",
    size: 38,
    rotate: 14,
    opacity: 0.7
  }, {
    top: "70%",
    left: "30%",
    size: 32,
    rotate: -10,
    opacity: 0.65
  }, {
    top: "78%",
    left: "58%",
    size: 46,
    rotate: 24,
    opacity: 0.8
  }, {
    top: "82%",
    left: "78%",
    size: 60,
    rotate: -14,
    opacity: 0.9
  }, {
    top: "88%",
    left: "20%",
    size: 42,
    rotate: 8,
    opacity: 0.75
  }, {
    top: "30%",
    left: "78%",
    size: 34,
    rotate: -20,
    opacity: 0.7
  }, {
    top: "54%",
    left: "48%",
    size: 30,
    rotate: 16,
    opacity: 0.6
  }];
  const stats = [{
    value: "15+",
    label: "lat doświadczenia"
  }, {
    value: "5.0",
    label: "opinii klientów",
    star: true
  }, {
    value: "PL/CZ",
    label: "obszar działania"
  }];
  return <section data-section-id="1351" id="zabezpiecz-swój-obiekt" className="bg-background text-foreground relative overflow-hidden py-32 md:py-44">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08]" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'><g fill='none' stroke='hsl(200 95% 45%)' stroke-width='1.5' stroke-linecap='round'><path d='M30 130 C 50 90, 70 70, 110 50'/><path d='M40 120 L 55 110'/><path d='M50 110 L 65 100'/><path d='M60 100 L 75 90'/><path d='M70 90 L 85 80'/><path d='M80 80 L 95 70'/><path d='M90 70 L 105 60'/><path d='M130 30 C 110 50, 100 70, 90 110'/><path d='M125 40 L 115 50'/><path d='M120 55 L 110 65'/><path d='M115 70 L 105 80'/><path d='M110 85 L 100 95'/></g></svg>\")",
      backgroundRepeat: "repeat",
      backgroundSize: "160px 160px"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        {stars.map((s, i) => <svg data-index={i} key={i} viewBox="0 0 24 24" className="absolute" style={{
        top: s.top,
        left: s.left,
        width: `${s.size}px`,
        height: `${s.size}px`,
        transform: `rotate(${s.rotate}deg)`,
        opacity: s.opacity,
        color: "hsl(200 95% 45%)"
      }}>
            <path d="M12 2.5l2.9 6.2 6.8.7-5.1 4.6 1.5 6.7L12 17.3l-6.1 3.4 1.5-6.7L2.3 9.4l6.8-.7L12 2.5z" fill="currentColor" />
          </svg>)}
      </div>

      {}
      <svg className="pointer-events-none absolute -bottom-20 -left-20 w-[520px] h-[520px] md:w-[680px] md:h-[680px]" style={{
      color: "hsl(200 95% 45%)",
      opacity: 0.16
    }} viewBox="0 0 600 600" fill="none" aria-hidden="true">
        <g stroke="currentColor" strokeWidth="3" strokeLinecap="round">
          <path d="M100 500 C 200 380, 280 280, 420 180" />
          <path d="M120 480 L 180 460" />
          <path d="M150 450 L 220 420" />
          <path d="M180 420 L 250 380" />
          <path d="M210 390 L 280 340" />
          <path d="M240 360 L 310 300" />
          <path d="M270 330 L 340 260" />
          <path d="M300 300 L 370 220" />
          <path d="M330 270 L 400 190" />
          <path d="M80 520 C 160 420, 240 360, 360 300" fill="none" />
          <path d="M110 510 L 130 490" />
          <path d="M140 490 L 170 470" />
        </g>
      </svg>

      <div ref={ref} className={`relative z-10 mx-auto max-w-4xl px-5 md:px-8 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="flex items-center justify-center gap-3 mb-10 md:mb-14">
          <span className="inline-block w-1 h-1" style={{
          backgroundColor: "hsl(200 95% 45%)"
        }} aria-hidden="true" />
          <span className="font-mono uppercase text-xs md:text-sm tracking-[0.18em]" style={{
          color: "hsl(200 95% 45%)"
        }}>
            HR-01.TECH — Hydroizolacja
          </span>
          <span className="inline-block w-1 h-1" style={{
          backgroundColor: "hsl(200 95% 45%)"
        }} aria-hidden="true" />
        </div>

        {}
        <div className="relative flex items-center justify-center mb-8">
          {}
          <div className="absolute rounded-lg pointer-events-none" style={{
          width: "min(520px, 90vw)",
          height: "min(520px, 90vw)",
          maxWidth: "520px",
          maxHeight: "520px",
          borderRadius: "8px",
          backgroundColor: "hsl(200 95% 45%)",
          opacity: 0.1
        }} aria-hidden="true" />
          <h2 className="relative font-default font-bold text-foreground leading-[1.02] tracking-tight" style={{
          fontSize: "clamp(2.25rem, 5vw, 4.25rem)",
          letterSpacing: "-0.025em"
        }}>
            Profesjonalna{" "}
            <span className="inline-block text-primary">
              hydroizolacja
            </span>{" "}
            Twojego dachu
          </h2>
        </div>

        {}
        <p className="font-default mx-auto max-w-2xl text-foreground/85 mb-10 md:mb-12" style={{
        fontSize: "clamp(1.125rem, 1.35vw, 1.3125rem)",
        lineHeight: 1.55
      }}>
          Zabezpiecz swój obiekt przed wilgocią dzięki nowoczesnej technologii bezspoinowych powłok natryskowych. Trwałość, odporność na UV i pełna szczelność bez konieczności zrywania starego pokrycia.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16 md:mb-20">
          <Button asChild className="rounded-lg bg-primary text-primary-foreground font-default font-semibold tracking-[0.01em] hover:bg-primary/90 transition-all duration-200 ease-out hover:translate-x-1 hover:translate-y-[-1px] hover:shadow-lg" style={{
          padding: "20px 40px",
          height: "auto",
          borderRadius: "0px",
          fontSize: "1.0625rem"
        }}>
            <Link to="/ContactPage">Bezpłatna wycena</Link>
          </Button>

          <Button asChild variant="outline" className="font-default font-semibold tracking-[0.01em] transition-colors duration-200 ease-out" style={{
          border: "2px solid hsl(200 95% 45%)",
          backgroundColor: "transparent",
          color: "hsl(200 95% 45%)",
          padding: "16px 32px",
          height: "auto",
          borderRadius: "0px",
          fontSize: "1rem"
        }}>
            <Link to="/OurSolutionsPage">Nasze usługi</Link>
          </Button>
        </div>

        {}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-0">
          {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-center gap-6 md:gap-0">
              <div className="flex items-center gap-2 px-4 md:px-6">
                {stat.star && <Star className="w-5 h-5" style={{
              color: "hsl(200 95% 45%)",
              fill: "hsl(200 95% 45%)"
            }} aria-hidden="true" />}
                <span className="font-default font-bold text-foreground" style={{
              fontSize: "1.25rem",
              letterSpacing: "-0.015em"
            }}>
                  {stat.value}
                </span>
                <span className="font-default text-foreground/70 text-sm md:text-base">
                  {stat.label}
                </span>
              </div>
              {i < stats.length - 1 && <div className="hidden md:flex items-center" aria-hidden="true">
                  <div className="h-[2px] w-[80px]" style={{
              backgroundImage: "repeating-linear-gradient(to right, hsl(200 95% 45%) 0 8px, transparent 8px 14px)"
            }} />
                  <span className="inline-block w-1.5 h-1.5 rounded-lg" style={{
              backgroundColor: "hsl(200 95% 45%)",
              borderRadius: "9999px"
            }} />
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}